import React, {useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom'

import './App.css';
import Protected from './Protected';

import LoginPage from './pages/LoginPage';
import Logout from './pages/Logout';
import ValidatePage from './pages/utils/ValidatePage';
import UploadMemberDetailsPage from './pages/rcm/UploadMemberDetailsPage';
import ReportsPage from './pages/rcm/ReportsPage';
import NoAccess from './pages/NoAccess';
import PathNotResolved from './pages/PathNotResolved';


import RCMUserManagement from './pages/rcm/usermanagement/UserManagementPage';
import RCMContentMemberManagement from './pages/rcm/components/ContentAddNewUser';
import RCMContentEditMemberManagement from './pages/rcm/components/ContentEditUserManagement';
// import ContentEditMemberManagement from './pages/met/components/ContentEditUserMangement';

//cn 



import RCMFileChecker from './pages/componenents/ContentRCMTeamDashboard/RCMFileChecker';
import RCMFileInsight from './pages/componenents/ContentRCMTeamDashboard/RCMFileInsight';
import RemoveUntouchMembers from './pages/componenents/ContentRCMTeamDashboard/RemoveUntouchMembers';


import RCMRemoveUntouchList from './pages/componenents/ContentRCMTeamDashboard/RCMRemoveUntouchList';

import AllObservations from './pages/Observations/pages/AllObservations/AllObservations';
import AddObservation from './pages/Observations/pages/AddObservation/AddObservation';
import ViewObservation from './pages/Observations/pages/ViewObservation/ViewObservation';
import { UserTabsProvider } from './pages/cn/components/common/UserTabsContext';

import ObservationLayout from './pages/componenents/Layout/ObservationLayout';



function App() {


  return (
    <>
      <UserTabsProvider>
        <Routes>
          <Route path="/">

            {/* Starts Common */}
            <Route exact path="/" element={<Navigate to="/login" />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/validate" element={<ValidatePage />} />
            <Route path="/no-access" element={<NoAccess />} title='Invalid Request' />
            <Route path="/logout" element={<Logout />} />
            <Route path="*" element={<PathNotResolved />} />
            {/* Ends Common */}

            {/* Starts DataMigrate */}
            <Route path="/upload-member-details" element={<Protected Component={UploadMemberDetailsPage} title='Upload Member Details' pathNew="upload-member-details" />} />
            <Route path="/reports" element={<Protected Component={ReportsPage} title='Reports Overview' pathNew="reports" />} />
            <Route path="/approval-reports" element={<Protected Component={RCMFileChecker} title='Upload File Checker' pathNew="approval-reports" />} />
            <Route path='/member-management-rcm' element={<Protected Component={RCMUserManagement} title='User Management' pathNew="member-management-rcm" />} />
            <Route path="/add-new-user-rcm" element={<Protected Component={RCMContentMemberManagement} title='Add New Member' pathNew="add-new-user-rcm" />} />
            <Route path='/edit-new-member-rcm/:id' element={<Protected Component={RCMContentEditMemberManagement} title='Edit New Member' pathNew="edit-new-member-rcm" />} />
            <Route path="/file-insight/:id?" element={<Protected Component={RCMFileInsight} title='Member Transfer' pathNew="file-insight" />} />
            <Route path="/remove-untouch" element={<Protected Component={RemoveUntouchMembers} title='Remove Untouch Members' pathNew="remove-untouch" />} />
            <Route path="/remove-untouch-list" element={<Protected Component={RCMRemoveUntouchList} title='Upload File Checker' pathNew="remove-untouch-list" />} />

            <Route element={<ObservationLayout />}>
              <Route path='/rcm-observations' element={<Protected Component={AllObservations} title='Observations' childrenProps={{ paths: { add: '/add-rcm-observation', view: '/rcm-observations' }, role: 'user' }} pathNew="rcm-observations" />} />
              <Route path='/add-rcm-observation' element={<Protected Component={AddObservation} title='Add Observation' pathNew="add-rcm-observation" childrenProps={{ paths: { observations: '/rcm-observations' }, role: 'user' }} />} />
              <Route path='/rcm-observations/:observationId' element={<Protected Component={ViewObservation} childrenProps={{ paths: { view: '/rcm-observations' }, role: 'user' }} title='View Observation' pathNew="rcm-observations" />} />
            </Route>
            {/* Ends DataMigrate */}
          </Route>
        </Routes>
    </UserTabsProvider>
    </>
  );
}

export default App;

